import { makeStyles } from "@material-ui/core/styles"

const styles = makeStyles(theme => ({
  adBillignInfo: {
    display: "flex",
    width: "100%",
  },
  saveButton: {
    color: theme.palette.error.main,
    font: "normal normal normal 12px/15px Helvetica",
    letterSpacing: "0px",
    opacity: 1,
    height: "25px",
    width: "59px",

    marginTop: "5px",
  },
  progress: {
    color: theme.palette.error.main,
  },
  subtitle: {
    fontSize: "14px",
    fontWeight: "bold",
    color: "#00003D",
    opacity: 1,
    whiteSpace: "nowrap",
    marginRight: theme.spacing(1),
    [theme.breakpoints.down("xs")]: {
      fontSize: "12px",
    },
  },
}))

export default styles
